import "leaflet/dist/leaflet.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";

import { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvents,
} from "react-leaflet";

import L from "leaflet";
import "leaflet-control-geocoder";

// FIX MARKER ICON
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function SearchControl({ setValue, setPosition }) {
  const map = useMap();

  useEffect(() => {
    const geocoder = L.Control.geocoder({
      defaultMarkGeocode: false,
      placeholder: "Search location...",
    })
      .on("markgeocode", function (e) {
        const lat = e.geocode.center.lat.toFixed(6);
        const lng = e.geocode.center.lng.toFixed(6);

        setPosition([lat, lng]);

        setValue("latitude", lat);
        setValue("longitude", lng);

        map.setView([lat, lng], 15);
      })
      .addTo(map);

    return () => {
      map.removeControl(geocoder);
    };
  }, [map, setValue, setPosition]);

  return null;
}

function MapClickHandler({ setValue, setPosition }) {
  useMapEvents({
    click(e) {
      const lat = e.latlng.lat.toFixed(6);
      const lng = e.latlng.lng.toFixed(6);

      setPosition([lat, lng]);

      setValue("latitude", lat);
      setValue("longitude", lng);
    },
  });

  return null;
}

export default function LocationPicker({
                        setValue,
                        latitude,
                        longitude,
                        }) {

  const [position, setPosition] = useState(
    latitude && longitude
      ? [parseFloat(latitude), parseFloat(longitude)]
      : null,
  );

  return (
    <MapContainer
      center={position ? position : [24.7136, 46.6753]}
      zoom={6}
      style={{
        height: "400px",
        width: "100%",
        borderRadius: "10px",
      }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <SearchControl setValue={setValue} setPosition={setPosition} />

      <MapClickHandler setValue={setValue} setPosition={setPosition} />

      {position && <Marker position={position} />}
    </MapContainer>
  );
}